import { render } from "./down.svg?vue&type=template&id=aeb8965c"
const script = {}

import exportComponent from "/Users/kevinschade/Code/bioeffect/New BIOEFFECt Wesbstie themes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__